import cn from 'classnames';

export interface AlertProps {
	testId?: string;
	type: 'default' | 'primary' | 'success' | 'warning' | 'danger';
	children?: React.ReactNode | null;
}

const Alert = (props: AlertProps) => {
	const { testId = 'Alert', type, children = null } = props;

	if (!children) {
		return null;
	}

	const isDefault = type === 'default';
	const isPrimary = type === 'primary';
	const isSuccess = type === 'success';
	const isWarning = type === 'warning';
	const isDanger = type === 'danger';

	return (
		<div
			data-testid={testId}
			role="alert"
			className={cn(
				'flex gap-2 rounded-lg px-4 py-3 align-text-top lg:px-6 lg:py-4',
				{
					'bg-slate-50': isDefault,
					'bg-sky-50': isPrimary,
					'bg-lime-50': isSuccess,
					'bg-amber-50': isWarning,
					'bg-red-50': isDanger,
				},
			)}
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
				className={cn('h-auto w-5 shrink-0 lg:w-6', {
					'stroke-slate-600': isDefault,
					'stroke-sky-700': isPrimary,
					'stroke-lime-700': isSuccess,
					'stroke-amber-700': isWarning,
					'stroke-red-700': isDanger,
				})}
			>
				<circle cx="12" cy="12" r="10" />
				<line x1="12" y1="16" x2="12" y2="12" />
				<line x1="12" y1="8" x2="12" y2="8" />
			</svg>
			<div
				className={cn('flex-1 self-center text-sm lg:text-base', {
					'text-slate-600': isDefault,
					'text-sky-700': isPrimary,
					'text-lime-700': isSuccess,
					'text-amber-700': isWarning,
					'text-red-700': isDanger,
				})}
			>
				{children}
			</div>
		</div>
	);
};

export default Alert;
